
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11473',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11473",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.208",
  "data-fetching-client": "static-1.9450",
  "foundations-components": "static-1.7471",
  "foundations-components-legacy": "static-1.496",
  "foundations-theming": "static-1.4182",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7778",
  "hub-http-shared-msw-handlers": "static-1.9412",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11194",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6245",
  "marketplace-storefront-base": "static-1.11533",
  "quartz": "static-1.6689",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16414",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2635",
  "reporting-testing-lib": "static-1.8333",
  "settings-ui-lib": "static-1.12293",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6677",
  "ui-addon-i18n": "static-1.10905",
  "ui-addon-react-router-dom": "static-1.9321",
  "unified-auth": "static-1.167",
  "unified-auth-core-lib": "static-1.448",
  "usage-tracker": "static-1.7105",
  "usage-tracker-core": "static-1.6955",
  "customer-data-property-utils": "static-1.7844",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15329",
  "marketplace-ui-common": "static-1.18868",
  "property-management-iframe": "static-1.12210",
  "quartz-config": "static-1.467",
  "quartz-core": "static-1.5908",
  "quartz-routing": "static-1.119",
  "quick-fetch": "static-1.3708",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4405",
  "ts-schema": "static-1.3879",
  "ui-universal-auth": "static-1.8653",
  "UIComponents": "static-3.8141",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3203",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2966",
  "quartz-webpack": "static-1.2913",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3740",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4606",
  "foundations-theming-specialty": "static-1.1898",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9201",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5148",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1120",
  "ui-fonts": "static-1.456",
  "ui-images": "static-2.1085",
  "bend-plugin-foundations-theming": "static-1.2665",
  "foundations-theming-base": "static-1.3167",
  "stylex": "static-1.27",
  "HeadJS": "static-2.704",
  "hs-test-utils-bend-plugin": "static-1.2889",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4102",
  "ai-components-ui-library": "static-1.8276",
  "ai-rendering-library": "static-1.9220",
  "chirp-fetch": "static-1.1657",
  "connections-embed-lib": "static-1.586",
  "copilot-toolkit": "static-1.10454",
  "laboratory-lib": "static-3.6935",
  "marketplace-embed": "static-1.21407",
  "marketplace-ui-details": "static-1.8764",
  "marketplace-ui-reviews": "static-1.18824",
  "marketplace-ui-tracking": "static-1.13039",
  "sanitize-text": "static-1.7913",
  "ui-addon-video-player": "static-1.8469",
  "usage-tracker-multi": "static-1.5519",
  "usage-tracker-session-replay": "static-1.4791",
  "wootric-nps": "static-1.6754",
  "apollo-link-hub-http": "static-2.4421",
  "immer": "static-1.33",
  "immerable": "static-1.3927",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2379",
  "reporting-data": "static-1.66400",
  "cssUtils": "static-1.725",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11502",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9984",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10145",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7095",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17401",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4296",
  "foundations-components-test-utils": "static-1.4954",
  "quartz-i18n": "static-1.364",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3504",
  "customer-data-objects": "static-1.7416",
  "property-translator": "static-1.5186",
  "frontend-preferences-client": "static-1.7697",
  "hs-promise-utils": "static-1.5364",
  "hubspot-apollo-client": "static-1.4652",
  "integrations-error-boundary-lib": "static-1.12744",
  "integrations-tracking-lib": "static-1.5357",
  "native-integrations-shared-strings": "static-1.7561",
  "reselect": "static-2.16",
  "sanitize": "static-1.4247",
  "superstore": "static-1.4544",
  "ui-shepherd-react": "static-3.9917",
  "ai-settings-ui-library": "static-1.7368",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4452",
  "immutable-less": "static-1.4426",
  "marketplace-ui-client-types": "static-1.16275",
  "nav-meta": "static-1.28818",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10009",
  "ui-addon-upgrades": "static-9.17612",
  "inbound-db-properties-service-client": "static-1.3650",
  "property-management-common": "static-1.4497",
  "ui-addon-iframeable": "static-1.8814",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.364",
  "quartz-head": "static-1.354",
  "quartz-test": "static-1.364",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2912",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20201",
  "ContentUtils": "static-1.67546",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2258",
  "customer-data-filters-ui": "static-1.38787",
  "customer-data-objects-ui-components": "static-1.12777",
  "customer-data-reference-ui-components": "static-1.12914",
  "embedded-academy-lib": "static-1.13404",
  "ExportDialog": "static-6.10161",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40589",
  "reporting-snowflake": "static-1.55018",
  "reporting-ui-components": "static-2.63671",
  "reporting-visualizations": "static-1.58476",
  "ui-addon-teams": "static-1.21203",
  "magpie-lib": "static-1.5367",
  "magpie-types": "static-1.4827",
  "simple-logging-lib": "static-1.2823",
  "navigation-components": "static-1.17181",
  "ai-studio-lib": "static-1.10919",
  "developer-experience-shared-components": "static-1.10241",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7757",
  "ui-tool-access": "static-1.9916",
  "usage-based-billing-components-lib": "static-1.7936",
  "usage-tracker-anonymous": "static-1.5522",
  "usage-tracker-public": "static-1.6916",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3480",
  "reference-resolvers": "static-1.7933",
  "ui-extensibility-client-types": "static-1.3720",
  "hubspot-apollo-cache": "static-1.111",
  "universal-page-editor-lib": "static-1.2769",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2108",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4843",
  "purchase-motions-components": "static-1.5446",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4281",
  "batch-promise": "static-1.1323",
  "crm-component-utils": "static-1.38420",
  "crm-properties-common-lib": "static-1.5644",
  "framework-data-schema-resolvers": "static-1.6643",
  "reference-resolvers-lite": "static-1.7863",
  "navigation-messaging": "static-1.6508",
  "hubspotter-http-shared-msw-handlers": "static-1.9410",
  "cms-field-types": "static-1.4578",
  "content-icons-ui": "static-1.2146",
  "conversations-skeleton-state": "static-1.7022",
  "crm-message-bus": "static-1.42271",
  "customer-data-filters-ui-msw-helpers": "static-1.21221",
  "customer-data-ui-utilities": "static-1.9597",
  "FormUrlGenerator": "static-2.4503",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6548",
  "multi-account-reference-resolvers": "static-1.742",
  "onboarding-tours": "static-1.16219",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12975",
  "academy-common-lib": "static-1.12864",
  "content-assistance-lib": "static-1.7410",
  "dashboard-lib": "static-1.80519",
  "file-manager-components": "static-1.22809",
  "getting-started-shared-tasks": "static-1.17803",
  "hubspot-prosemirror": "static-1.17530",
  "hubspot-prosemirror-plugins": "static-1.17522",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19427",
  "share-with-third-party-component-lib": "static-1.8464",
  "ui-addon-draggable": "static-3.4538",
  "ui-asset-management-lib": "static-1.10672",
  "ui-business-units-lib": "static-1.8797",
  "user-context": "static-1.4867",
  "growth-payments-core": "static-1.24647",
  "reporting-plugins": "static-1.9947",
  "reporting-reports": "static-1.66078",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.499",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28803",
  "react-codemirror": "static-1.10399",
  "apps-service-types": "static-1.3652",
  "oauth-service-types": "static-1.4014",
  "onboarding-scopes": "static-1.6236",
  "onboarding-tours-client": "static-1.4433",
  "platform-infra-nav-components": "static-1.7468",
  "subscription-experience-data-types": "static-1.14552",
  "crm-record-cards-service-types": "static-1.3427",
  "location-customization-utils-lib": "static-1.8468",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4297",
  "nav-client-types": "static-1.2129",
  "purchase-motions-api": "static-1.5449",
  "signup-constants": "static-1.18335",
  "signup-ui-url-generator": "static-2.7838",
  "trials-service-types": "static-1.3698",
  "card-properties-lib": "static-1.43444",
  "crm-actions": "static-1.6069",
  "crm-cards-data": "static-1.1154",
  "crm-cards-sdk": "static-1.42829",
  "customer-data-properties": "static-1.50713",
  "customer-data-properties-shared-msw-handlers": "static-1.8739",
  "customer-data-tracking": "static-1.6654",
  "conditional-properties-service-client": "static-1.3599",
  "crm-pipelines-api-client-types": "static-1.3939",
  "multi-currency-client-types": "static-1.3493",
  "external-options-client-types": "static-1.3959",
  "react-dnd-compat": "static-1.4395",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5124",
  "growth-onboarding-confetti": "static-1.2843",
  "growth-onboarding-next-action-utils": "static-1.1268",
  "onboarding-tours-utils": "static-1.285",
  "ui-shepherd-tracker": "static-1.7298",
  "academy-service-client": "static-1.3455",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27872",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8158",
  "video-components-external": "static-1.10486",
  "video-data-lib": "static-1.34144",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8342",
  "payment-link-components": "static-1.22864",
  "ui-addon-emoji-picker": "static-1.9661",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6803",
  "data-token-picker": "static-1.15999",
  "FileManagerLib": "static-1.38449",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5017",
  "getting-started-shared-tasks-store": "static-1.16921",
  "campaign-roi-lib": "static-1.8185",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.164",
  "eligibility-engine-service-types": "static-1.2979",
  "crm_data": "static-4.91128",
  "crm-links": "static-1.6028",
  "customer-data-sidebar": "static-2.45340",
  "enrichment-properties-lib": "static-1.14894",
  "crm-fe-perf": "static-1.22679",
  "calling-global-api": "static-1.63560",
  "calling-internal-common": "static-1.31066",
  "calling-lifecycle-internal": "static-1.64942",
  "calling-lifecycle-messages": "static-1.57236",
  "commerce-products-lib": "static-1.8774",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.446",
  "inbounddb-objects-service-types": "static-1.4025",
  "meetings-icalendar-utils-lib": "static-1.406",
  "object-builder-ui-client": "static-1.47877",
  "pipeline-validation-client-types": "static-1.3761",
  "property-value-citations": "static-1.1327",
  "pulse": "static-1.278",
  "smart-property-lib": "static-1.5776",
  "tiered-pricing": "static-1.787",
  "ui-addon-form-validation": "static-1.10767",
  "growth-onboarding-feedback-components": "static-1.6358",
  "content-media-composition-data-lib": "static-1.11351",
  "content-media-compositions": "static-2.15358",
  "media-bridge-lib": "static-1.18521",
  "commerce-tours-lib": "static-1.5676",
  "growth-onboarding-reliability": "static-1.4861",
  "sales-checkout-service-client": "static-1.3451",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21265",
  "sales-email-signature-service-client": "static-1.3618",
  "audio-components": "static-1.5574",
  "FileManagerCore": "static-1.38308",
  "FileManagerImages": "static-1.35960",
  "video-components": "static-1.12489",
  "crm_universal": "static-1.21617",
  "customer-data-email": "static-1.17625",
  "calling-error-reporting": "static-1.31072",
  "card-payment-highlight-lib": "static-1.36423",
  "card-subscription-highlight-lib": "static-1.38782",
  "commerce-billing-lib": "static-1.18423",
  "commerce-contract-lib": "static-1.11059",
  "customer-data-content": "static-1.26828",
  "invoices-highlight-card-lib": "static-1.53923",
  "orders-highlight-card-lib": "static-1.20807",
  "products-highlight-card-lib": "static-1.17058",
  "project-storage": "static-1.4505",
  "quotes-highlight-card-lib": "static-1.71054",
  "breeze-intelligence-kit": "static-1.5282",
  "crm-source-interpretation-lib": "static-1.5101",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9495",
  "policy-lib": "static-1.6554",
  "shared-worker-versioning": "static-1.10809",
  "calling-usage-tracker": "static-1.6311",
  "voice-sms-access-library": "static-1.162",
  "products-iframe-lib": "static-1.7241",
  "products-ui-components-shared-msw-handlers": "static-1.9794",
  "directed-graph": "static-1.710",
  "event-emitter": "static-1.720",
  "react-tinymce": "static-1.54547",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9558",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53673",
  "tinymce-plugins": "static-1.56787",
  "tinymce-themes": "static-1.55643",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4307",
  "video-embed": "static-1.34978",
  "social-insights-client-types": "static-1.21265",
  "sequences-lib": "static-1.7647",
  "ui-gdpr-components": "static-1.10120",
  "commerce-shared-components-lib": "static-1.17847",
  "commerce-subscription-lib": "static-1.36359",
  "commerce-tools-ui-lib": "static-1.9726",
  "utility-belt": "static-1.2315",
  "payments-enrollment-embed-lib": "static-1.21902",
  "products-ui-components": "static-1.39293",
  "quotes-client-types": "static-1.37142",
  "quotes-ui-lib": "static-1.79773",
  "SalesContentIndexUI": "static-3.8861",
  "accounting-integrations-ui-components": "static-1.6684",
  "invoices-ui-lib": "static-1.53939",
  "commerce-products-api": "static-1.1917",
  "SafeStorage": "static-1.4177",
  "invoices-iframe-lib": "static-1.55997",
  "quotes-modal-lib": "static-1.101730",
  "calling-orchestration-schema": "static-1.34939",
  "sales-views-client-types": "static-1.4065",
  "hub-http-contrib": "static-1.2817",
  "interframe": "static-3.4564",
  "tinymce-data": "static-1.39758",
  "ui-addon-sales-email": "static-1.4986",
  "layout-dnd-components": "static-1.11983",
  "layout-dnd-utils": "static-1.10958",
  "ui-brand-identity-lib": "static-1.13737",
  "NamespacedHubStyle": "static-2.8871",
  "outpost": "static-1.3979",
  "sequences-client-types-lib": "static-1.7504",
  "customer-data-associations": "static-1.7108",
  "framework-data-table": "static-2.11349",
  "customer-data-rte": "static-1.32383",
  "cv-backend-services": "static-1.1490",
  "growth-onboarding-empty-states": "static-1.5324",
  "InboxConnectUtils": "static-4.14153",
  "payments-post-enroll-local-storage-lib": "static-1.4885",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7089",
  "commerce-permissions": "static-1.525",
  "commerce-tax-lib": "static-1.282",
  "property-description-translator": "static-1.3632",
  "FireAlarmUi": "static-1.4302",
  "sales-templates-service-types-lib": "static-1.3969",
  "commerce-analytics-service-client": "static-1.3439",
  "totals-ui-components": "static-1.22932",
  "ContentData": "static-1.67621",
  "layout-data-lib": "static-1.9283",
  "deal-intel-decorators": "static-1.1154",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27651",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3613",
  "advanced-menus-core": "static-1.14776",
  "advanced-menus-lib": "static-1.11756",
  "ui-memberships-settings-lib": "static-1.33356",
  "deal-intel-utils": "static-1.1158",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14775",
  "simple-menus-lib": "static-1.16292"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11473",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.208",
  "data-fetching-client": "/data-fetching-client/static-1.9450",
  "foundations-components": "/foundations-components/static-1.7471",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.496",
  "foundations-theming": "/foundations-theming/static-1.4182",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7778",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9412",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11194",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6245",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11533",
  "quartz": "/quartz/static-1.6689",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16414",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2635",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8333",
  "settings-ui-lib": "/settings-ui-lib/static-1.12293",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6677",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10905",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9321",
  "unified-auth": "/unified-auth/static-1.167",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.448",
  "usage-tracker": "/usage-tracker/static-1.7105",
  "usage-tracker-core": "/usage-tracker-core/static-1.6955",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7844",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15329",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18868",
  "property-management-iframe": "/property-management-iframe/static-1.12210",
  "quartz-config": "/quartz-config/static-1.467",
  "quartz-core": "/quartz-core/static-1.5908",
  "quartz-routing": "/quartz-routing/static-1.119",
  "quick-fetch": "/quick-fetch/static-1.3708",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4405",
  "ts-schema": "/ts-schema/static-1.3879",
  "ui-universal-auth": "/ui-universal-auth/static-1.8653",
  "UIComponents": "/UIComponents/static-3.8141",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3203",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2966",
  "quartz-webpack": "/quartz-webpack/static-1.2913",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3740",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4606",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1898",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9201",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5148",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1120",
  "ui-fonts": "/ui-fonts/static-1.456",
  "ui-images": "/ui-images/static-2.1085",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2665",
  "foundations-theming-base": "/foundations-theming-base/static-1.3167",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.704",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2889",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4102",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8276",
  "ai-rendering-library": "/ai-rendering-library/static-1.9220",
  "chirp-fetch": "/chirp-fetch/static-1.1657",
  "connections-embed-lib": "/connections-embed-lib/static-1.586",
  "copilot-toolkit": "/copilot-toolkit/static-1.10454",
  "laboratory-lib": "/laboratory-lib/static-3.6935",
  "marketplace-embed": "/marketplace-embed/static-1.21407",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8764",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18824",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13039",
  "sanitize-text": "/sanitize-text/static-1.7913",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8469",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5519",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4791",
  "wootric-nps": "/wootric-nps/static-1.6754",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4421",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3927",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2379",
  "reporting-data": "/reporting-data/static-1.66400",
  "cssUtils": "/cssUtils/static-1.725",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11502",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9984",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10145",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7095",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17401",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4296",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4954",
  "quartz-i18n": "/quartz-i18n/static-1.364",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3504",
  "customer-data-objects": "/customer-data-objects/static-1.7416",
  "property-translator": "/property-translator/static-1.5186",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7697",
  "hs-promise-utils": "/hs-promise-utils/static-1.5364",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4652",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12744",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5357",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7561",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4247",
  "superstore": "/superstore/static-1.4544",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9917",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7368",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4452",
  "immutable-less": "/immutable-less/static-1.4426",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16275",
  "nav-meta": "/nav-meta/static-1.28818",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10009",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17612",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3650",
  "property-management-common": "/property-management-common/static-1.4497",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8814",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.364",
  "quartz-head": "/quartz-head/static-1.354",
  "quartz-test": "/quartz-test/static-1.364",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2912",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20201",
  "ContentUtils": "/ContentUtils/static-1.67546",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2258",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38787",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12777",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12914",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13404",
  "ExportDialog": "/ExportDialog/static-6.10161",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40589",
  "reporting-snowflake": "/reporting-snowflake/static-1.55018",
  "reporting-ui-components": "/reporting-ui-components/static-2.63671",
  "reporting-visualizations": "/reporting-visualizations/static-1.58476",
  "ui-addon-teams": "/ui-addon-teams/static-1.21203",
  "magpie-lib": "/magpie-lib/static-1.5367",
  "magpie-types": "/magpie-types/static-1.4827",
  "simple-logging-lib": "/simple-logging-lib/static-1.2823",
  "navigation-components": "/navigation-components/static-1.17181",
  "ai-studio-lib": "/ai-studio-lib/static-1.10919",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10241",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7757",
  "ui-tool-access": "/ui-tool-access/static-1.9916",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7936",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5522",
  "usage-tracker-public": "/usage-tracker-public/static-1.6916",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3480",
  "reference-resolvers": "/reference-resolvers/static-1.7933",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3720",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.111",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2769",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2108",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4843",
  "purchase-motions-components": "/purchase-motions-components/static-1.5446",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4281",
  "batch-promise": "/batch-promise/static-1.1323",
  "crm-component-utils": "/crm-component-utils/static-1.38420",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5644",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6643",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7863",
  "navigation-messaging": "/navigation-messaging/static-1.6508",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9410",
  "cms-field-types": "/cms-field-types/static-1.4578",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7022",
  "crm-message-bus": "/crm-message-bus/static-1.42271",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21221",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9597",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4503",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6548",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.742",
  "onboarding-tours": "/onboarding-tours/static-1.16219",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12975",
  "academy-common-lib": "/academy-common-lib/static-1.12864",
  "content-assistance-lib": "/content-assistance-lib/static-1.7410",
  "dashboard-lib": "/dashboard-lib/static-1.80519",
  "file-manager-components": "/file-manager-components/static-1.22809",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17803",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17530",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17522",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19427",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8464",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4538",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10672",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8797",
  "user-context": "/user-context/static-1.4867",
  "growth-payments-core": "/growth-payments-core/static-1.24647",
  "reporting-plugins": "/reporting-plugins/static-1.9947",
  "reporting-reports": "/reporting-reports/static-1.66078",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.499",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28803",
  "react-codemirror": "/react-codemirror/static-1.10399",
  "apps-service-types": "/apps-service-types/static-1.3652",
  "oauth-service-types": "/oauth-service-types/static-1.4014",
  "onboarding-scopes": "/onboarding-scopes/static-1.6236",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4433",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7468",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14552",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3427",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8468",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4297",
  "nav-client-types": "/nav-client-types/static-1.2129",
  "purchase-motions-api": "/purchase-motions-api/static-1.5449",
  "signup-constants": "/signup-constants/static-1.18335",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7838",
  "trials-service-types": "/trials-service-types/static-1.3698",
  "card-properties-lib": "/card-properties-lib/static-1.43444",
  "crm-actions": "/crm-actions/static-1.6069",
  "crm-cards-data": "/crm-cards-data/static-1.1154",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42829",
  "customer-data-properties": "/customer-data-properties/static-1.50713",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8739",
  "customer-data-tracking": "/customer-data-tracking/static-1.6654",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3599",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3939",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3493",
  "external-options-client-types": "/external-options-client-types/static-1.3959",
  "react-dnd-compat": "/react-dnd-compat/static-1.4395",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5124",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2843",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1268",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.285",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7298",
  "academy-service-client": "/academy-service-client/static-1.3455",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27872",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8158",
  "video-components-external": "/video-components-external/static-1.10486",
  "video-data-lib": "/video-data-lib/static-1.34144",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8342",
  "payment-link-components": "/payment-link-components/static-1.22864",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9661",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6803",
  "data-token-picker": "/data-token-picker/static-1.15999",
  "FileManagerLib": "/FileManagerLib/static-1.38449",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5017",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16921",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8185",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.164",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2979",
  "crm_data": "/crm_data/static-4.91128",
  "crm-links": "/crm-links/static-1.6028",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45340",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14894",
  "crm-fe-perf": "/crm-fe-perf/static-1.22679",
  "calling-global-api": "/calling-global-api/static-1.63560",
  "calling-internal-common": "/calling-internal-common/static-1.31066",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64942",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57236",
  "commerce-products-lib": "/commerce-products-lib/static-1.8774",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.446",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4025",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.406",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47877",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3761",
  "property-value-citations": "/property-value-citations/static-1.1327",
  "pulse": "/pulse/static-1.278",
  "smart-property-lib": "/smart-property-lib/static-1.5776",
  "tiered-pricing": "/tiered-pricing/static-1.787",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10767",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6358",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11351",
  "content-media-compositions": "/content-media-compositions/static-2.15358",
  "media-bridge-lib": "/media-bridge-lib/static-1.18521",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5676",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4861",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3451",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21265",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3618",
  "audio-components": "/audio-components/static-1.5574",
  "FileManagerCore": "/FileManagerCore/static-1.38308",
  "FileManagerImages": "/FileManagerImages/static-1.35960",
  "video-components": "/video-components/static-1.12489",
  "crm_universal": "/crm_universal/static-1.21617",
  "customer-data-email": "/customer-data-email/static-1.17625",
  "calling-error-reporting": "/calling-error-reporting/static-1.31072",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36423",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38782",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18423",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11059",
  "customer-data-content": "/customer-data-content/static-1.26828",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53923",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20807",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17058",
  "project-storage": "/project-storage/static-1.4505",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71054",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5282",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5101",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9495",
  "policy-lib": "/policy-lib/static-1.6554",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10809",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6311",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.162",
  "products-iframe-lib": "/products-iframe-lib/static-1.7241",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9794",
  "directed-graph": "/directed-graph/static-1.710",
  "event-emitter": "/event-emitter/static-1.720",
  "react-tinymce": "/react-tinymce/static-1.54547",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9558",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53673",
  "tinymce-plugins": "/tinymce-plugins/static-1.56787",
  "tinymce-themes": "/tinymce-themes/static-1.55643",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4307",
  "video-embed": "/video-embed/static-1.34978",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "sequences-lib": "/sequences-lib/static-1.7647",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10120",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17847",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36359",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9726",
  "utility-belt": "/utility-belt/static-1.2315",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21902",
  "products-ui-components": "/products-ui-components/static-1.39293",
  "quotes-client-types": "/quotes-client-types/static-1.37142",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79773",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8861",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6684",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53939",
  "commerce-products-api": "/commerce-products-api/static-1.1917",
  "SafeStorage": "/SafeStorage/static-1.4177",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55997",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101730",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34939",
  "sales-views-client-types": "/sales-views-client-types/static-1.4065",
  "hub-http-contrib": "/hub-http-contrib/static-1.2817",
  "interframe": "/interframe/static-3.4564",
  "tinymce-data": "/tinymce-data/static-1.39758",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4986",
  "layout-dnd-components": "/layout-dnd-components/static-1.11983",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10958",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13737",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8871",
  "outpost": "/outpost/static-1.3979",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7504",
  "customer-data-associations": "/customer-data-associations/static-1.7108",
  "framework-data-table": "/framework-data-table/static-2.11349",
  "customer-data-rte": "/customer-data-rte/static-1.32383",
  "cv-backend-services": "/cv-backend-services/static-1.1490",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5324",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14153",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4885",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7089",
  "commerce-permissions": "/commerce-permissions/static-1.525",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.282",
  "property-description-translator": "/property-description-translator/static-1.3632",
  "FireAlarmUi": "/FireAlarmUi/static-1.4302",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3969",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3439",
  "totals-ui-components": "/totals-ui-components/static-1.22932",
  "ContentData": "/ContentData/static-1.67621",
  "layout-data-lib": "/layout-data-lib/static-1.9283",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1154",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27651",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3613",
  "advanced-menus-core": "/advanced-menus-core/static-1.14776",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11756",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33356",
  "deal-intel-utils": "/deal-intel-utils/static-1.1158",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14775",
  "simple-menus-lib": "/simple-menus-lib/static-1.16292"
}
};
